import {
  Dialog, DialogTitle, DialogContent, DialogActions, IconButton,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { GlobalSearch } from 'components/GlobalSearch';

interface Props {
  onBack: () => void;
  onClose: () => void;
}

export const SingleLink = ({
  onBack, onClose,
}: Props) => (
  <Dialog fullWidth onClose={onClose} aria-labelledby="title" open>
    <div className="absolute right-2 top-2">
      <IconButton aria-label="close" onClick={onClose}>
        <Close />
      </IconButton>
    </div>
    <DialogTitle id="title">Import Social Link</DialogTitle>
    <DialogContent>
      <div className="mb-2">
        We support social media platforms including Twitter, Instagram,
        YouTube, TikTok, and Twitch.
      </div>
      <GlobalSearch label="Track a link" trackOnly />
    </DialogContent>
    <DialogActions>
      <button type="button" className="btn-primary-outlined" onClick={onBack}>
        Back
      </button>
    </DialogActions>
  </Dialog>
);
